const Hooks = {};

Hooks.TranslateCQL = {
  updated() {
    // shamelessly pulled from https://stackoverflow.com/a/38340730
    const removeEmpty = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
        // recurse
        // eslint-disable-next-line no-param-reassign
        else if (obj[key] == null) delete obj[key]; // delete
      });
    };

    const jsobj = JSON.parse(this.el.dataset.json);
    removeEmpty(jsobj);
    const yaml = window.YAML.safeDump(jsobj);
    this.pushEvent('set-yaml-view', { yaml });
  },
};

Hooks.FormatSQL = {
  updated() {
    const { sql } = this.el.dataset;
    const prettySQL = window.sqlFormatter.format(sql);
    this.pushEvent('set-sql-preview', { sql: prettySQL });
  },
};

// TODO need to move all of these into the same hook
// ... this isn't right how I'm creating a hook per action
Hooks.SelectTab = {
  mounted() {
    this.el.addEventListener('click', () => {
      const { tab } = this.el.dataset;
      const cqlEditor = document.getElementById('cql-editor');
      this.pushEvent('set-cql-yaml', { yaml: cqlEditor.value });
      this.pushEvent('select-tab', { tab });
    });
  },
};

Hooks.RunQuery = {
  mounted() {
    this.el.addEventListener('click', () => {
      let isValid = true;
      const cqlEditor = document.getElementById('cql-editor');
      try {
        window.YAML.safeLoad(cqlEditor.value);
      } catch (e) {
        isValid = false;
        window.toast({
          message: e,
          type: 'is-danger',
        });
      }
      if (isValid) this.pushEvent('run-query', { cql: cqlEditor.value });
    });
  },
};

Hooks.SetContext = {
  mounted() {
    this.el.addEventListener('click', () => {
      let isValid = true;
      let ctx = document.getElementById('context-editor').value;

      try {
        ctx = JSON.parse(ctx);
      } catch (e) {
        isValid = false;
        window.toast({
          message: e,
          type: 'is-danger',
        });
      }
      if (isValid) this.pushEvent('set-context', { context: ctx });
    });
  },
};

Hooks.ContextUserSearch = {
  mounted() {
    this.el.addEventListener('click', () => {
      const { value } = document.getElementById('user-search-value');
      this.pushEvent('user-search', { user_search_value: value });
    });
  },
};

export default Hooks;
